export const DEVICE_IMAGE_MAP: { [key: string]: string } = {
    HeatPump: 'assets/img/heatpump.svg',
    SaltChlorinator: 'assets/img/alarm-salt-chlorinator.svg',
    DosingPump: 'assets/img/alarm-dosing-pump.svg',
    VsPump: 'assets/img/alarm-vs-pump.svg',
    UvLamp: 'assets/img/uv-light.svg',
    HeatPumpSg: 'assets/img/heatpump.svg',
    Aux3: 'assets/img/aux-off.svg',
    Aux4: 'assets/img/aux-off.svg',
    BackWash: 'assets/img/backwash.svg',
    PoolLight: 'assets/img/pool-light-off.svg',
    WaterMeter:"assets/img/WaterMeter_Icon.svg"
  };

  export const CRITICAL_INFO_MAP:{ [key: string]: string } = {
    1: "assets/img/critical-alarm-ico.svg",
    2 : "assets/img/info.svg"

  }
  
  export const DEFAULT_DEVICE_IMAGE = 'assets/img/default-image.png';